import type { ServerEvent } from '@/types/ServerEvent';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class ServerSideDisabledUserEvent extends EventV2<ServerEvent> {}
